import * as yup from 'yup';
import i18next from 'i18next';

export const RECIPES_COMPONENTS_FIELD_ARRAY_NAME = 'recipeComponents';

export const RECIPE_COMPONENTS_VALIDATION_INPUTS = [
  {
    name: 'quantity',
    rule: yup
      .number()
      .test(
        'notEqualToZero',
        i18next.t('ADMIN.RECIPES.FORM_FIELD_NOT_EQUAL_TO_ERROR', {
          field: i18next.t('GENERAL.QUANTITY'),
          value: 0,
        }),
        (value) => value !== 0,
      )
      .required(
        i18next.t('ADMIN.RECIPES.FORM_FIELD_REQUIRED_ERROR', {
          field: i18next.t('GENERAL.QUANTITY'),
        }),
      ),
  },
];
